<template>
  <v-card-item class="bg-widget-color">
    <v-card-title>
      <v-icon v-if="
        currentStep != step.PRODUCT_PREVIEW &&
        this.$store.state.orderStatus === null
      " @click="back()">mdi-chevron-left</v-icon>
      <span class="text-wrap" v-if="currentStep === step.PRODUCT_PREVIEW">
        {{ product.product_name }}
      </span>

      <span class="text-wrap" v-else-if="currentStep === step.CUSTOMER_INFORMATION">
        {{ $t("header.title.customer-info") }}
      </span>

      <span class="text-wrap" v-else> {{ $t("header.title.payment") }} </span>
    </v-card-title>

    <v-card-subtitle>
      <span class="text-wrap" v-if="currentStep === step.PRODUCT_PREVIEW">
        {{ `${product.product_location.productlocation_address},
        ${product.product_location.location_city.locationcity_name},
        ${product.product_location.location_city.location_province.locationprovince},
        ${product.product_location.location_city.location_province.location_country.locationcountry_name}`
        }}
      </span>
    </v-card-subtitle>
  </v-card-item>

  <div v-if="needSelectDate && currentStep === step.PRODUCT_PREVIEW">
    <v-card-item>
      <div class="d-flex justify-space-between align-center py-1">
        <v-icon color="widget-color">mdi-calendar</v-icon>

        <div v-if="selectedDate" class="flex-grow-1 ps-1 d-flex flex-column">
          <div class="font-weight-bold">
            <span v-if="diffDate == 0">
              {{ $t("header.date-selection.date-condition.today") }}
            </span>
            <span v-else>
              {{ $t("header.date-selection.date-condition.tommorow") }}
            </span>
          </div>
          <div>
            {{ selectedDate.format("ddd, DD MMM YYYY") }}
          </div>
        </div>
        <div class="flex-grow-1" v-else>
          {{ $t("header.date-selection.not-selected") }}
        </div>

        <v-btn @click="dialogDate = true" color="widget-color" variant="flat" class="text-none text-caption">{{
          $t("header.date-selection.change-date") }}</v-btn>
      </div>
    </v-card-item>

    <v-divider class="border-opacity-100" color="widget-color" thickness="2"></v-divider>

    <v-dialog width="auto" persistent v-model="dialogDate">
      <v-card>
        <v-card-item class="overflow-auto">
          <v-card-title>
            {{ $t("header.date-selection.dialog.title") }}
          </v-card-title>
          <v-date-picker hide-header :min="minPickDate" v-model="pickDate" show-adjacent-months></v-date-picker>
        </v-card-item>

        <v-card-actions>
          <v-spacer> </v-spacer>
          <v-btn @click="selectDate" color="widget_color" class="text-none text-caption">
            {{ $t("header.date-selection.dialog.pick-date") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

  <div v-else-if="currentStep !== step.PRODUCT_PREVIEW">
    <v-card-item>
      <div class="d-flex justify-space-between align-center">
        <div class="flex-grow-1">
          <div v-for="cartItem in cart" :key="cartItem" class="d-flex justify-space-between align-center py-1">
            <v-icon color="widget-color">mdi-ticket-confirmation-outline</v-icon>

            <div class="flex-grow-1 ps-1 d-flex flex-column">
              <div class="font-weight-bold">
                {{ cartItem.productType.producttype_name }}
              </div>
              <div>{{ cartItem.qty }} Tiket</div>
            </div>
          </div>
        </div>
        <v-btn v-if="this.$store.state.orderStatus === null" @click="backToStepOne" rounded="xl" color="widget-color"
          variant="tonal" class="text-none text-caption font-weight-bold">
          {{ $t("header.change-ticket") }}
        </v-btn>
      </div>
    </v-card-item>

    <v-divider class="border-opacity-100" color="widget-color" thickness="2"></v-divider>
  </div>
</template>

<script>
import { step } from "@/config/step";

export default {
  data() {
    return {
      product: this.$store.state.product,
      pickDate: null,
      selectedDate: null,
      dialogDate: true,
      needSelectDate: false,
      step: step,
    };
  },
  computed: {
    minPickDate() {
      return this.$moment().format("MM-DD-YYYY");
    },
    diffDate() {
      const selectedDate = this.selectedDate;
      const today = this.$moment();

      return selectedDate.startOf("day").diff(today.startOf("day"), "days");
    },
    currentStep() {
      return this.$store.state.step;
    },
    cart() {
      return this.$store.getters.sortedCartByTypeID;
    },
  },
  methods: {
    selectDate() {
      this.selectedDate = this.$moment(this.pickDate);
      this.dialogDate = false;
    },
    back() {
      this.$store.commit("backStep");
    },
    backToStepOne() {
      this.$store.commit("backToStepOne");
    },
  },
};
</script>

<style></style>